


























import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class SharingCard extends Vue {
  public url = window.location.origin+"/#/results";

  constructor() {
    super();
    if (this.$store.getters.answers) {
      this.url +=
        "?answers=" + JSON.stringify(this.$store.getters.answers.toJson());
    }
  }
  @Emit("close")
  onClose() {
    return;
  }
  copy(): void {
    /* Get the text field */
    const copyText: any = document.getElementById("url-input");

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    navigator.clipboard.writeText(copyText.value);

    /* Alert the copied text */
    alert("Copied the text: " + copyText.value);
  }
}
